import { useNavigate } from "@reach/router";
import { T } from "../hooks/useLanguage"
import Button from "./basic/Button";
import { prepareEntryIntentForCurrentLocation } from "../features/entryFlow/entryIntentStorage";

export default function EmailLoginButton({ enabled = true, className }) {
  const navigate = useNavigate();
  return (
    <Button
      className={className}
      onClick={() => {
        prepareEntryIntentForCurrentLocation();
        navigate("/verify");
      }}
      disabled={!enabled}
    >
      <T>home.loginemail</T>
    </Button>
  );
}
